import { PermissionAccessType } from '@/types/coda-qa-user/permissions.types';

export const DEFAULT_ACCESS_TYPE: PermissionAccessType = {
  read: false,
  create: false,
  update: false,
  delete: false,
};
export const PermissionsGroupName = {
  DASHBOARD: 'dashboard',
  IMPORTS: 'imports',
  EXPORTS: 'exports',
  CUSTOMS: 'customs',
  REPORTS: 'reports',
  ORGANIZATION_SETTINGS: 'organizationSettings',
  EDI: 'edi',
  AIR: 'airImports',
  PHOTOS: 'photos',
  INTERFACILITY: 'interfacility',
  FINANCE: 'finances',
  INVENTORY_LOCATIONS: 'inventoryLocations',
  CHARGE_COLLECT_MORE_DETAILS: 'chargesCollectMoreDetails',
  CHARGES_VOID_INVOICE: 'voidInvoice',
} as const;

export const PermissionsImportFeatures = {
  LOAD_PLAN: 'ipiLoadPlan',
  LOAD_GUIDE: 'ipiLoadGuide',
  IPI_TRACKING: 'ipiTracking',
  IPI_LOADING: 'ipiLoading',
  IPI_RECEIVING: 'ipiReceiving',
  MANIFEST: 'manifest',
  INVENTORY: 'inventory',
  MBL: 'mbl',
  HBL: 'hbl',
} as const;

export const PermissionsEdiFeatures = {
  IMPORTS: 'imports',
};
export const PermissionsExportsFeatures = {
  ON_HAND: 'onHand',
  LOAD_PLAN: 'exportLoadPlan',
  LOAD_GUIDE: 'exportLoadGuide',
  BARCODE_SCANNING: 'barcodeScanning',
} as const;

export const PermissionsInterfacilityFeatures = {
  LOAD_GUIDE: 'interfacilityLoadGuide',
  LOAD_PLAN: 'interfacilityLoadPlan',
  LOADING: 'interfacilityLoading',
} as const;

export const PermissionsReportsFeatures = {
  ADMIN: 'admin',
  IMPORT: 'import',
  EXPORT: 'export',
  ACCOUNTING: 'accounting',
  IPI: 'ipi',
} as const;

export const PermissionsFinanceFeatures = {
  CHARGES: 'charges',
  INVOICES: 'invoices',
};

export const PermissionsFinanceInvoiceFunctions = {
  VOID_INVOICE: 'voidInvoice',
  FINANCE_VOID_INVOICE: 'financeVoidInvoice',
} as const;

export const PermissionsPhotosFeatures = {
  PHOTO_ACTIONS: 'photoActions',
} as const;

export const PermissionsAccountingReportsFunctions = {
  CREDIT_MEMO_AUDIT: 'creditMemoAudit',
  COMMISSION: 'commission',
  INVOICE: 'invoice',
  WAREHOUSE_COLLECT: 'warehouseCollect',
  UNINVOICED: 'uninvoiced',
  TRANSLOAD_STORAGE: 'transloadStorage',
  CUSTOMER_INVOICES: 'customerInvoices',
  COURIER: 'courier',
  FLAT_INVOICE: 'flatInvoice',
  SALES_JOURNAL: 'salesJournal',
  IPI_WEEKLY_BILLING: 'ipiWeeklyBilling',
} as const;

export const PermissionsAdminReportsFunctions = {
  SUMMARY_ACTIVITY: 'summaryActivity',
  UNIT_INVENTORY: 'unitInventory',
  INVENTORY_INTERNAL: 'inventoryInternal',
  UNFINALIZED: 'unfinalized',
  MONTHLY_ORIGIN: 'monthlyOrigin',
} as const;

export const PermissionsExportReportsFunctions = {
  EXPORT_INVENTORY: 'exportInventory',
} as const;

export const PermissionsImportReportsFunctions = {
  OPEN_INBOND_AGING: 'openInbondAgind',
  IMPORT_INVENTORY: 'importInventory',
  TRANSLOAD_INVENTORY: 'transloadInventory',
  PENDING_CONTAINERS: 'pendingContainers',
  HOLD_BY_CUSTOMER: 'holdByCustomer',
  HBL_LOT_KPI: 'hblLotKpi',
  MBL_LOT_KPI: 'mblLotKpi',
  RELEASED_TO_GO: 'releasedToGO',
  WINDOW_RELEASE: 'windowRelease',
} as const;

export const PermissionsIpiReportsFunctions = {
  IPI_AGING: 'ipiAging',
  IPI_ACTIVITY: 'ipiActivity',
} as const;

export const PermissionsCustomsFeatures = {
  AMS: 'amsStatus',
} as const;

export const PermissionsMBLFunctions = {
  MBL_PTT: 'mblPtt',
  MBL_PRINT: 'mblPrint',
  MBL_HBL_LIST: 'mblHblList',
  MBL_MILESTONES: 'mblMilestones',
  MBL_ATTACHMENTS: 'mblAttachments',
  MBL_ATTACHMENTS_DOCUMENTS: 'mblAttachmentsDocuments',
  MBL_ATTACHMENTS_PHOTOS: 'mblAttachmentsPhotos',
  MBL_AUTO_CHARGES: 'mblAutoCharges',
  MBL_MANUAL_CHARGES: 'mblManualCharges',
  MBL_LFD: 'warehouseLfd',
  FORCE_ZERO: 'forceZeroCharges',
  CREATE_CREDIT_MEMO: 'createCreditMemoCharges',
  AUTO_CHARGE_AMOUNT: 'autoChargeAmount',
  AUTO_CHARGE_BILL_TO: 'autoChargeBillTo',
  MBL_POL_POD_DETAILS: 'mblPolPodDetails',
  MBL_CONTAINER_DETAILS: 'mblContainerDetails',
  MBL_DISCHARGE_DETAILS: 'mblDischargeDetails',
  MBL_CFS_RECEIPT: 'mblCfsReceipt',
  MBL_NOTES: 'mblNotes',
  MBL_INTERNAL_NOTES: 'mblInternalNotes',
  MBL_EXTERNAL_NOTES: 'mblExternalNotes',
  MBL_DISPATCH_NOTES: 'mblDispatchNotes',
  MBL_DELIVERY_NOTES: 'mblDeliveryNotes',
  MBL_FINALIZE: 'mblFinalize',
  MBL_SEND_ALERT: 'mblSendAlert',
  MBL_FILE_ALL_CUSTOM: 'mblFileAllCustom',
  MBL_TARIFF_EFFECTIVE_DATE: 'mblTariffEffectiveDate',
  MBL_SEND_OSD_REPORT: 'mblSendOSDReport',
  MBL_LABEL_8BY11: 'mblLabel8by11',
  HBL_LABEL_8BY11: 'hblLabel8by11',
} as const;

export const PermissionsHBLFunctions = {
  HBL_IT: 'hblIt',
  HBL_PRINT: 'hblPrint',
  HBL_MILESTONES: 'hblMilestones',
  HBL_ATTACHMENTS: 'hblAttachments',
  HBL_ATTACHMENTS_DOCUMENTS: 'hblAttachmentsDocuments',
  HBL_ATTACHMENTS_PHOTOS: 'hblAttachmentsPhotos',
  HBL_MANUAL_CHARGES: 'hblManualCharges',
  HBL_AUTO_CHARGES: 'hblAutoCharges',
  HBL_REOPEN: 'hblReopen',
  FORCE_ZERO: 'forceZeroCharges',
  CREATE_CREDIT_MEMO: 'createCreditMemoCharges',
  AUTO_CHARGE_AMOUNT: 'autoChargeAmount',
  AUTO_CHARGE_BILL_TO: 'autoChargeBillTo',
  HBL_REFERENCE: 'hblReference',
  HBL_CARGO_DETAILS: 'hblCargoDetails',
  HBL_RELEASE: 'hblRelease',
  HBL_NOTES: 'hblNotes',
  HBL_HEAD_LOAD_DELIVERY: 'hblHeadLoadDelivery',
  HBL_GENERATE_IT: 'hblGenerateIt',
  HBL_SEND_ALERT: 'hblSendAlert',
  HBL_DETENTION_NOTICE: 'hblDetentionNotice',
  HBL_SEGREGATE: 'hblSegregate',
  HBL_UN_RELEASE: 'hblUnRelease',
  HBL_COMMODITY: 'hblCommodity',
  HBL_EXCEPTION_NOTES: 'hblExceptionNotes',
  HBL_ACCOUNTING_NOTES: 'hblAccountingNotes',
  HBL_INTERNAL_NOTES: 'hblInternalNotes',
  HBL_E_GUARANTEE_BY: 'hblEGuaranteeBy',
  HBL_EXTERNAL_NOTES: 'hblExternalNotes',
  HBL_IPI_EVENT_NOTES: 'hblIPIEventNotes',
  HBL_IPI_NOTES: 'hblIpiNotes',
  HBL_DEVAN_NOTES: 'hblDevanNotes',
  HBL_MANIFESTED_DATA: 'hblManifestedData',
  HBL_RECEIVED_DATA: 'hblReceivedData',
  HBL_MARKS: 'hblMarks',
  HBL_ACTUAL_MARKS: 'hblActualMarks',
  HBL_MULTIPLE_INVENTORY_LOCATIONS: 'hblMultipleInventoryLocations',
  HBL_LABEL_8BY11: 'hblLabel8by11',
  HBL_HEADLOAD: 'headload',
} as const;

export const PermissionsOnHandFunctions = {
  ON_HAND_PRINT: 'onHandPrint',
  ON_HAND_ATTACHMENTS: 'onHandAttachments',
  ON_HAND_MILESTONES_TAB: 'onHandMilestones',
  ON_HAND_AUTO_CHARGES: 'onHandAutoCharges',
  ON_HAND_MANUAL_CHARGES: 'onHandManualCharges',
  FORCE_ZERO: 'forceZeroCharges',
  COPY_PACKAGES: 'copyPackages',
  CREATE_CREDIT_MEMO: 'createCreditMemoCharges',
  AUTO_CHARGE_AMOUNT: 'autoChargeAmount',
  AUTO_CHARGE_BILL_TO: 'autoChargeBillTo',
  ON_HAND_LABEL_8BY11: 'onHandLabel8by11',
} as const;

export const PermissionsIpiLoadingFunctions = {
  IPI_LOADS: 'ipiLoadingLoads',
  IPI_INVENTORY: 'ipiLoadingInventory',
  IPI_FILTER: 'ipiLoadingFilter',
  IPI_GENERATE_LOAD: 'ipiLoadingGenerateLoad',
  IPI_MANUAL_CONTAINER: 'ipiLoadingManualContainer',
  IPI_GROUP_CONTAINER: 'ipiLoadingGroupContainers',
  IPI_CREATE_WEEKLY_FUTURE_LOAD: 'ipiLoadingCreateWeeklyFutureLoad',
  IPI_LOAD_CONTAINER_FROM_INVENTORY: 'ipiLoadingLoadContainerFromInventory',
} as const;

export const PermissionsImportLoadPlanFunctions = {
  LOCK: 'ipiLoadPlanLock',
  MAKE_LOAD_GUIDE: 'ipiLoadPlanMakeLoadGude',
  EMPTY_CONTAINER: 'ipiLoadPlanEmptyContainer',
  EDIT_ETD: 'editETD',
} as const;

export const PermissionsImportInventoryFunctions = {
  INVENTORY_GROUP: 'inventoryGroup',
} as const;

export const PermissionsImportLoadGuideFunctions = {
  NOTES: 'ipiLoadGuideNotes',
  HAND_OFF: 'ipiLoadGuideHandOff',
  HAND_OFF_REVERSAL: 'loadGuideHandOffReversal',
  PICTURES: 'ipiLoadGuidePictures',
  DOWNLOAD_PDF: 'ipiLoadGuideDownloadPDF',
  ATTACHMENTS: 'loadGuideAttachments',
  ARRIVAL_DATE: 'ipiLoadGuideArrivalDate',
  AUTO_CHARGES: 'ipiLoadGuideAutoCharges',
  MARK_AS_LOADED: 'ipiLoadGuideMarkAsLoaded',
  DELIVERY_ORDER: 'ipiLoadGuideDeliveryOrder',
  MANUAL_CHARGES: 'ipiLoadGuideManualCharges',
  CREATE_CREDIT_MEMO: 'createCreditMemoCharges',
  FORCE_ZERO: 'forceZeroCharges',
  AUTO_CHARGE_AMOUNT: 'autoChargeAmount',
  AUTO_CHARGE_BILL_TO: 'autoChargeBillTo',
  PROFIT_AND_LOSS: 'ipiLoadGuideProfitAndLoss',
} as const;

export const PermissionsExportLoadGuideFunctions = {
  HAND_OFF: 'createHandoff',
  HAND_OFF_REVERSAL: 'loadGuideHandoffReversal',
  ATTACHMENTS: 'loadGuideAttachments',
  PICTURES: 'exportLoadGuidePictures',
  DOWNLOAD_PDF: 'exportLoadGuidePDF',
  MARK_AS_LOADED: 'exportMarkLoaded',
  CREATE_CREDIT_MEMO: 'createCreditMemoCharges',
  FORCE_ZERO: 'forceZeroCharges',
  AUTO_CHARGE_AMOUNT: 'autoChargeAmount',
  AUTO_CHARGE_BILL_TO: 'autoChargeBillTo',
} as const;

// AIR IMPORTS PERMISSIONS

export const PermissionsAirImportsFeatures = {
  MAWB: 'airMbl',
  HBL: 'airHbl',
} as const;
export const PermissionsAirMblFunctions = {
  AUTO_CHARGE_AMOUNT: 'autoChargeAmount',
  AUTO_CHARGE_BILL_TO: 'autoChargeBillTo',
  CREATE_CREDIT_MEMO: 'createCreditMemoCharges',
  FORCE_ZERO: 'forceZeroCharges',
  ATTACHMENTS: 'airMblAttachments',
  AUTO_CHARGES: 'airMblAutoCharges',
  HBL_LIST: 'airMblHblList',
  MANUAL_CHARGES: 'airMblManualCharges',
  MILESTONES: 'airMblMilestones',
  PRINT: 'airMblPrint',
  PTT: 'airMblPtt',
  WAREHOUSE_LFD: 'warehouseLfd',
} as const;

export const PermissionsAirHBLFunctions = {
  AUTO_CHARGE_AMOUNT: 'autoChargeAmount',
  AUTO_CHARGE_BILL_TO: 'autoChargeBillTo',
  CREATE_CREDIT_MEMO: 'createCreditMemoCharges',
  FORCE_ZERO: 'forceZeroCharges',
  ATTACHMENTS: 'airHblAttachments',
  AUTO_CHARGES: 'airHblAutoCharges',
  IT: 'airHblIt',
  MANUAL_CHARGES: 'airHblManualCharges',
  MILESTONES: 'airHblMilestones',
  PRINT: 'airHblPrint',
  REOPEN: 'airHblReopen',
} as const;

export const PermissionsInterfacilityLoadingFunctions = {
  CREATE_FUTURE_LOAD: 'interfacilityLoadingCreateWeeklyFutureLoad',
} as const;

export const PermissionsInventoryLocationsFeatures = {
  INVENTORY_LOCATIONS: 'inventoryLocations',
} as const;
